module.exports = __webpack_public_path__ + "img/hori.0e418064.png";